import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Select } from 'antd';
import { withRouter } from 'react-router-dom';
import { getManagers, getManagerStats, clearManagerStats } from 'actions/superuser';
import { DateTimePicker } from 'elements';
import CN from 'classnames';
import { DDhhmmss } from 'utils/helper';
import RecentReply from './RecentReply';

import './Stats.css';

const { Option } = Select;


function mapState(state) {
  return {
    ...state.superuser
  };
}

function mapDispatch(dispatch) {
  return {
    getManagers() {
      return getManagers(dispatch);
    },
    clearManagerStats() {
      return clearManagerStats(dispatch);
    },
    getManagerStats(data) {
      return getManagerStats(dispatch, data);
    }
  };
}

class Stats extends Component {

  state = {
    managerUUID: null,
    dateStart: null,
    dateEnd: null
  };

  static propTypes = {
    managers: React.PropTypes.array,
    managerStats: React.PropTypes.object,
    getManagers: React.PropTypes.func,
    clearManagerStats: React.PropTypes.func,
    getManagerStats: React.PropTypes.func
  };

  componentWillMount() {
    this.props.getManagers();
  }

  componentWillUnmount() {
    this.props.clearManagerStats();
  }

  get pageTitle() {
    return 'Manager stats';
  }

  handleStatChange(dateStart, dateEnd, managerUUID) {
    if (dateStart && dateEnd && managerUUID) {
      const data = {
        admin: managerUUID,
        dateEnd: dateEnd.format(),
        dateStart: dateStart.format('YYYY-MM-DD HH:mm:ss')
      };
      this.props.getManagerStats(data);
    }
  }

  handleManagerChange(value) {
    this.setState({ managerUUID: value });
    this.handleStatChange(this.state.dateStart, this.state.dateEnd, value);
  }

  handleDateRangeChange(dateStart, dateEnd) {
    this.setState({ dateEnd, dateStart });
    this.handleStatChange(dateStart, dateEnd, this.state.managerUUID);
  }

  render() {
    const { managers, managerStats } = this.props;
    const { dateStart, dateEnd } = this.state;
    const rawEnvs = Object.keys(managerStats);
    const envs = rawEnvs.sort();
    return (
      <div className="stat-container">
        <div className="page-title">{ this.pageTitle }</div>
        <Select
          showSearch
          style={ { width: 200 } }
          placeholder="Select a manager"
          onChange={ v => this.handleManagerChange(v) }
        >
          {
            managers.map(i => <Option key={ i.uuid } value={ i.uuid }>{ i.username }</Option>)
          }
        </Select>
        <DateTimePicker
          value={ [dateStart, dateEnd] }
          exportData={ (a, b) => this.handleDateRangeChange(a, b) }
        />
        { (dateStart && dateEnd) &&
        <div className="env-stats">
          <div>
            from: { dateStart.format('YYYY/MM/DD HH:mm:ss') }
          </div>
          <div>
            to: { dateEnd.format('YYYY/MM/DD HH:mm:ss') }
          </div>
        </div>
        }
        {
          envs.map(k => {
            const envStats = managerStats[k];
            const { messageStats, adminTimeStats } = envStats;

            if (!messageStats || !adminTimeStats) {
              return null;
            }

            const freeAnswers = messageStats.filter(i => !i.respToPaidMessage);
            const NumberOfPaidAnswers = messageStats.length - freeAnswers.length;
            const totalTime = adminTimeStats.reduce((a, i) => a + i.time, 0);
            return (<div className="env-stats" key={ k }>
              <div className={ CN('bold', { 'blue-total': k === 'Total' }) }>{ k }</div>
              <div>
                Paid Answers: { NumberOfPaidAnswers }
              </div>
              <div>
                Free Answers: { freeAnswers.length }
              </div>
              <div>
                Time Active: { DDhhmmss(totalTime) }
              </div>
            </div>);
          })
        }
        { managerStats['Total'] &&
        <div className="env-stats">
          <div className={ CN('bold', 'recentReplies') }>Recent Replies:</div>
          { managerStats['Total'].sortedMessages.length ?
            managerStats['Total'].sortedMessages.map((v, i) =>
              <RecentReply
                key={ v.uuid + v.env + i }
                data={ v }
                index={ i }
              />) : 'No messages found for selected date range'
          }
        </div>
        }
      </div>);
  }
}

export default withRouter(connect(mapState, mapDispatch)(Stats));



// WEBPACK FOOTER //
// ./src/pages/stats/Stats.jsx